import { render, staticRenderFns } from "./DocumentManager.vue?vue&type=template&id=16a4611c&scoped=true&"
import script from "./DocumentManager.vue?vue&type=script&lang=js&"
export * from "./DocumentManager.vue?vue&type=script&lang=js&"
import style0 from "./DocumentManager.vue?vue&type=style&index=0&id=16a4611c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a4611c",
  null
  
)

export default component.exports